export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="about-text section-title">
            <h2>About Unreal Kingdoms</h2>
            <h5>We're here to build the next virtual home for humanity</h5>
          </div>
          <div className="col-xs-12 col-md-12 about-cards">
            <div className="col-md-4 col-xs-12">
              <div className="card">
                <h1>01</h1>
                <h3>We’re eager 🎯</h3>
                <p>
                  Create your own story and shape your own destiny in a fully
                  immersive open world gaming experience. Be part of an
                  ever-growing community where dreams truly do come true.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-xs-12">
              <div className="card">
                <h1>02</h1>
                <h3>What is metaverse? 🔎</h3>
                <p>
                  The future is here! Earn crypto, play games, and make new
                  friends in a virtual world with a real crypto-economy. Explore
                  a vast world filled with breathtaking scenery and fascinating
                  cultures.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-xs-12">
              <div className="card">
                <h1>03</h1>
                <h3>We have big plans... 📚</h3>
                <p>
                  Are you an artist? Bring your creations to life within the
                  metaverse and launch your own NFT career: virtual houses need
                  virtual art!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
